// import { array_get } from "../../../utils.js";

// import * as R from "ramda";

export const allFiles = state => state.allFiles;
